import React from 'react'
import _ from 'lodash'

import RightClickMenu from './RightClickMenu'

const EventWrapper = ({ event, displayTimesheetEntry, children }) => {
  const trigger = children

  const contextMenuItems = [
    { label: 'Add time entry', value: 'entry_timesheet', handleClick: () => displayTimesheetEntry(true, event) },
    {
      label: 'View ticket time entries',
      value: 'view_timesheets',
      handleClick: () => { window.open(`/tickets/${event.meta.taskable_id}?tab=timesheets`, '_blank') }
    }
  ]

  if ((event.meta.event_type === 'task' || event.meta.event_type === 'object') && event.meta.taskable_type === 'Ticket') {
    return <RightClickMenu trigger={trigger} mainObjectId={event.meta.id} objectType="event" menuItems={contextMenuItems} />
  }

  return trigger
}

export default EventWrapper
